import { FormEditActions } from "@arelia-components/form/FormEditActions";
import { useHandleFormActions } from "@arelia-hooks/formikHooks";
import { Card, CardContent, CardHeader, TextField, Typography } from "@mui/material";
import { FormikProps } from "formik";
import { ChangeEvent } from "react";
import { EditForm } from "./LabelDetailsContainer";

type Props = {
  formik: FormikProps<EditForm>;
  editing: boolean;
  setEditing: (editing: boolean) => void;
  handeChange: (name: keyof EditForm) => (event: ChangeEvent<HTMLInputElement>) => void
};

export default function LabelDetailsPresenter({ formik, editing, setEditing, handeChange }: Props) {
  const { handleSubmit, handleReset, handleEdit } = useHandleFormActions<EditForm>(setEditing, formik);

  return (<Card sx={{
    gridColumn: "span 4",
    gridRow: "span 3"
  }}>
    <CardHeader
      title="Band Details"
      action={<FormEditActions edit={editing} handleEdit={handleEdit} handleReset={handleReset} handleSubmit={handleSubmit} />}
    />
    <CardContent sx={styles.cardContent(editing)}>
      {editing
        ? <TextField
          label="Name"
          value={formik.values.bandName || ""}
          onChange={handeChange('bandName')}
          size="small"
          fullWidth
        />
        : <Typography variant="h3" sx={styles.textOverflow}>{formik.values.bandName}</Typography>
      }
      {editing
        ? <TextField
          label="location"
          value={formik.values.location || ""}
          onChange={handeChange('location')}
          size="small"
          fullWidth
        />
        : <Typography variant="subtitle1" sx={styles.textOverflow}>Location: {formik.values.location}</Typography>
      }
    </CardContent>
  </Card>);
}

const styles = {
  cardContent: (editing: boolean) => ({
    gap: editing ? "10px" : 0,
    justifyContent: "space-evenly"
  }),
  textOverflow: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    width: "100%",
    height: "100%"
  }
}